import React, { Component } from 'react'

export class StudentProfile extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}

export default StudentProfile
